import { useState } from 'react';
import dynamic from 'next/dynamic';

import { Edit } from '@/icons';
import { Container, Text } from '@/atoms';
import { Button, CardStepNumber, Grid } from '@/molecules';

const StepperNumeros = ({ bloque, id, className }: any) => {
  const [isShowCustomTag, setShowCustomTag] = useState(false);
  let CustomTagModal = null;

  if (isShowCustomTag) {
    CustomTagModal = dynamic(
      () => import('@/organisms').then((mod) => mod.CustomTagModal),
      {
        ssr: false,
      },
    );
  }

  return (
    <Container
      as="section"
      wrapper
      id={bloque?.id ?? id}
      {...(className && { className })}
    >
      <div className="px flex flex-col">
        <div className="mb-8 flex flex-col items-center gap-y-4 self-center">
          {bloque.pretitulo && (
            <div
              className="u-label u-label--s font-bold text-secondary-500"
              dangerouslySetInnerHTML={{ __html: bloque.pretitulo }}
            />
          )}

          {bloque.titulo && (
            <Text
              as={bloque.headingType}
              className="u-headline text-[52px] leading-[52px]"
            >
              {bloque.titulo}
            </Text>
          )}

          <Grid
            xs={1}
            sm={1}
            md={2}
            lg={2}
            outline={false}
            className="mt-6 md:mt-16 md:[&>div:nth-child(2n)]:!border-r-0 [&>div:nth-last-child(-n+1)]:!border-b-0 md:[&>div:nth-last-child(-n+2)]:!border-b-0"
          >
            {bloque.steps.map((step: any, index: number) => (
              <CardStepNumber
                key={index}
                image={step.imagen}
                description={step.descripcion}
                number={step.numero}
                className="border-b border-dashed border-primary-900 md:border-r"
              />
            ))}
          </Grid>

          {bloque.showButton && (
            <>
              {CustomTagModal && (
                <CustomTagModal
                  open={isShowCustomTag}
                  setOpen={setShowCustomTag}
                />
              )}

              <Button
                variant="primary"
                size="large"
                type="button"
                className="mt-6 !h-[46px] min-w-full !rounded-[60px] sm:mt-16 sm:!min-w-0 sm:!max-w-fit"
                onClick={(e: any) => {
                  e.preventDefault();
                  setShowCustomTag(true);
                }}
              >
                personaliza tu etiqueta
                <Edit width={16} height={16} />
              </Button>
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default StepperNumeros;

StepperNumeros.displayName = 'FlexibleStepperNumeros';
